import styled from "styled-components";

export const PhotoStyledWrapper = styled.div``;

export const PhotoContainer = styled.div`
width: 100%;

`;